import * as Config from '@/Config';
import VuexPersist from 'vuex-persist';
import authentication from './Module/Authentication/Persist';
import global from './Module/Global/Persist';

/**
  ┌────────────────────────────────────────────────────────────────────────────┐
  │                                                                            │
  │ Store/Persist                                                              │
  │                                                                            │
  │ Custom storage adapter that mixes with Vuex and Vuex-Persist. Ordinarily   │
  │ those would combine with LocalStorage, but this plugin will prioritize     │
  │ chrome.storage.local if it's available.                                    │
  │                                                                            │
  │ Example:                                                                   │
  │                                                                            │
  │     import Persist from '~/store/persist';                                 │
  │                                                                            │
  │     new Vuex.Store({                                                       │
  │         ...                                                                │
  │         plugins: [                                                         │
  │             new VuexPersist(Persist.options),                              │
  │         ]                                                                  │
  │     });                                                                    │
  │                                                                            │
  │ @see https://github.com/championswimmer/vuex-persist                       │
  │                                                                            │
  └────────────────────────────────────────────────────────────────────────────┘
*/

const persist = new VuexPersist({
	asyncStorage: false,
	key: Config.App.STORAGE_KEY,
	reducer: (state: IKeyValue) => ({
		authentication: authentication(state.authentication),
		global: global(state.global),
	}),
	storage: window.localStorage,
});

export default persist.plugin;
